import { Component, AfterViewInit, AfterViewChecked, ViewChild, ViewContainerRef } from '@angular/core';
import { CtFilterContainerComponent } from '../ct-filter-container/ct-filter-container.component';
import { ADN_PLUS, EntityField } from '../../models';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { CtFormComponent } from '../ct-form/ct-form.component';
import { CtInputCheckBoxComponent } from '../ct-input-checkbox/ct-input-checkbox.component';
import { InputBaseComponent } from '../input-base.component';

@Component({
  selector: 'ct-filter-window',
  templateUrl: './ct-filter-window.component.html',
  styleUrls: ['./ct-filter-window.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'/*,
    '[class]': "'btn ' + getButtonClasses() + ' '+ getStyleClass()"*/
  }
})
export class CtFilterWindowComponent extends CtrlBaseComponent implements AfterViewInit, AfterViewChecked {

  public isPopUpOpen : boolean = false;
  private selectedAdns: ADN_PLUS[] = [];
  private filterContainerRef : CtFilterContainerComponent;

  @ViewChild('filterForms', { read: ViewContainerRef, static : false }) filterWindowTarget : ViewContainerRef;

  constructor() { 
    super();
  }

  ngAfterViewInit(): void {
    this.prepareMetaData();
    this.paintChildren( this.getMetaData(), this.filterWindowTarget);
    this.prepareInputs();
  }

  ngAfterViewChecked(): void {
    this.filterContainerRef = this.utilService.getComponentRef(this.getListenedComponentId());
  }

  /**
   * show/hide popUp window
   */
  public changePopWindowState(): void {
    this.isPopUpOpen = !this.isPopUpOpen;
  }

  /**
   * It gets the form data, emits it to the parent component, and then changes the pop window state
   * @param {boolean} [isFromClean=true] - boolean = true
   * @returns the value of the variable selectedAndCopy.
   */
  public executeSearch(isFromClean : boolean = true): void {
    if(!isFromClean){
      let selectedAndCopy = JSON.stringify(this.selectedAdns);
      this.getFormData();
      if(selectedAndCopy === JSON.stringify(this.selectedAdns)) return;
    } else {
      this.getFormData();
    }
    this.emitToParent();
    if(!isFromClean) this.changePopWindowState();
  }

  /**
   * Cleans the child forms, then emit to the parent
   */
  public cleanForm(): void {
    this.childElements.forEach((childForm : CtFormComponent) => {
      childForm.cleanForm();
    })
    this.changePopWindowState();
    this.setSelectedAdns(this.cleanAllFilters());
    this.emitToParent();
  }

  /**
   * The function emits the selected ADNs to the parent component
   */
  private emitToParent(): void{
    this.filterContainerRef.setAdnsFromFilterWindowChild(this.getSelectedAdns());
  }

  /**
   * The function recieves an array of ADN_PLUS objects from the parent component, and then resets the
   * checkbox of the changed entity to its initial state
   * @param {ADN_PLUS[]} selectedAdnsFromParent - The array of ADN_PLUS objects that were selected by the
   * parent component.
   * @param {EntityField} changedEntity - The entity that was changed in the parent form.
   */
  public recieveSelectedAdnsFromParent(selectedAdnsFromParent : ADN_PLUS[], changedEntity : EntityField): void {
    if(selectedAdnsFromParent.length === 0 && changedEntity === null){
      this.setSelectedAdns(this.cleanAllFilters());
      this.resetFormElements();
      this.emitToParent();
      return;
    }
    this.resetFormElements(changedEntity);
    this.selectedAdns = selectedAdnsFromParent;
    this.executeSearch(true);
  }

  /**
   * It loops through all the child forms, binds the form to the ADN, gets the form elements, and then
   * loops through the ADN's array entities and sets the display value to the label value of the form
   * element
   */
  private getFormData(): void {
    this.selectedAdns = [];
    this.childElements.forEach((childForm : CtFormComponent) => {
      childForm.bindFormToAdn();
      const formElements = childForm.getFormElements();
      childForm.getBindingAdn().ArrayEntities.List.forEach(( entity : EntityField, i : number) => {
        entity.Display = formElements[i]['labelValue'];
      })
      this.selectedAdns.push(childForm.getBindingAdn())
    })
  }

  /**
   * Internal property set up to forms
   */
  private prepareMetaData(): void {
    let tmpMetaData = this.getMetaData();
    tmpMetaData.models.forEach(( modelForm : any) => {
      modelForm.controlProperties['isFilterForm'] = true;
    });
  }

  /**
   * Cleans the selected ADNS
   */
  private cleanAllFilters(): ADN_PLUS[] {
    this.selectedAdns.forEach((adn : ADN_PLUS) => {
      adn.ArrayEntities.List.forEach((entity : EntityField) => {
        entity.Value = 'N';
      })
    })
    return this.selectedAdns;
  }

  /**
   * It gets all the child inputs of the filter component and sets their `isFilterInput` property to
   * true
   */
  private prepareInputs(): void {
    this.getChildsByType(CtInputCheckBoxComponent,true).forEach(( input : InputBaseComponent ) => {
      input.setIsFilterInput(true);
    })
  }

  private resetFormElements(changedEntity? : EntityField): void {
    this.childElements.forEach((childForm : CtFormComponent) => {
      childForm.getFormElements().forEach((formElement : CtInputCheckBoxComponent) => {
        if(changedEntity){
          if(formElement.getModelId() === changedEntity.Name && formElement.getLabelValue() === changedEntity.Display){
            formElement.resetToInitState();
            formElement.formControl.nativeElement.checked = false;
          }
        } else {
          formElement.resetToInitState();
          formElement.formControl.nativeElement.checked = false;
        }
      });
    });
  }

  //GETTERS
  getSelectedAdns(): ADN_PLUS[] { return this.selectedAdns }

  //SETTERS
  setSelectedAdns(selectedAdns: ADN_PLUS[]): void { this.selectedAdns = selectedAdns }

}